import merge from 'lodash/merge'
import { Analytics } from '../services/analytics'

export const getActualPage = (): string|null => {
  return localStorage.getItem('actualPage')
}

export const setActualPage = (page: string) => {
  localStorage.setItem('actualPage', page)
}

export const getErrorFields = (errors: any) => {
  const getKeys: any = (obj: any) =>
    Object.keys(obj).flatMap(k =>
      Object(obj[k]) === obj[k] ? [...getKeys(obj[k])] : k
    )
  return getKeys(errors).join('; ')
}

export const trackErrors = (errors: any, defaultTrackingData: any) => {
  const errorFields = getErrorFields(errors)
  if (errorFields) {
    const errorData = {
      [Analytics.keys.eventType(0)]: 'Form',
      [Analytics.keys.eventAction(0)]: 'Field error',
      [Analytics.keys.linkInformation(0)]: 'Field error',
      [Analytics.keys.errorFields()]: errorFields,
    }
    Analytics.setTrackingData(merge({}, defaultTrackingData, errorData))
    Analytics.trackInteraction()
  }
}

export const trackErrorsMessage = (errors: any, defaultTrackingData: any, errorMessage: string) => {
  const errorFields = getErrorFields(errors)
  if (errorFields) {
    const errorData = {
      [Analytics.keys.eventType(0)]: 'Form',
      [Analytics.keys.eventAction(0)]: 'Field error',
      [Analytics.keys.linkInformation(0)]: 'Field error',
      [Analytics.keys.errorFields()]: errorMessage,
    }
    Analytics.setTrackingData(merge({}, defaultTrackingData, errorData))
    Analytics.trackInteraction()
  }
}

export const trackAbort = (lastTouchedField: string, defaultTrackingData: any) => {
  const abortData = {
    [Analytics.keys.eventType(0)]: 'Form',
    [Analytics.keys.eventAction(0)]: 'Aborted',
    [Analytics.keys.linkInformation(0)]: 'Form abort',
    [Analytics.keys.lastTouchedField()]: lastTouchedField,
  }
  Analytics.setTrackingData(merge({}, defaultTrackingData, abortData))
  Analytics.trackInteraction()
}

export const trackFirstCustomerInteraction = (defaultTrackingData: any) => {
  const firstCustomerInteractionData = {
    [Analytics.keys.eventType(0)]: 'Form',
    [Analytics.keys.eventAction(0)]: 'Start typing',
    [Analytics.keys.linkInformation(0)]: 'Start typing',
  }
  Analytics.setTrackingData({...defaultTrackingData, ...firstCustomerInteractionData})
  Analytics.trackInteraction()
}

export const trackInteractionSuccess = (linkInformation: string, defaultTrackingData: any) => {
  const buttonData = {
    [Analytics.keys.eventType(0)]: 'interAction',
    [Analytics.keys.eventAction(0)]: 'Success',
    [Analytics.keys.linkInformation(0)]: linkInformation,
  }
  Analytics.setTrackingData({...defaultTrackingData, ...buttonData})
  Analytics.trackInteraction()
}
